import instance from '../config/axios';
import {
  CartDetailType,
  Product,
  ReactSelectOptionProp,
} from '../interface/interface';
import { stringify } from 'qs';
import { calculateOutOfStockEnum } from '../utils/outOfStockStatus';

type GetAccessories = (
  token: string,
  brand: Array<ReactSelectOptionProp>,
  form: Array<ReactSelectOptionProp>,
  cart?: CartDetailType,
) => Promise<Array<Product> | null>;

export const getAccessories: GetAccessories = async (
  token,
  brand,
  form,
  cart,
) => {
  try {
    const result = await instance({
      url: `/api/v1/accessories?${stringify({
        sort: {
          sortByBrand: brand?.map((e) => e.value),
          sortByForm: form?.map((e) => e.value),
        },
      })}`,
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const quantityCheckedAccessories = result?.data?.map((product: any) => {
      const orderedQuantity =
        cart?.line_items?.find(
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          (item: any) => `${item?.product_id}` === `${product.product_code}`,
        )?.quantity ?? 0;
      return {
        ...product,
        orderedQuantity,
        outOfStock: calculateOutOfStockEnum(product, orderedQuantity),
      };
    });
    return quantityCheckedAccessories;
  } catch (error) {
    console.error(error);
    return null;
  }
};
